import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wraps a route that requires authentication AND the department_chief role.
 */
export default function ChiefRoute({ children }) {
  const { isLoggedIn, hasRole, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRole('department_chief')) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
